export default "__VITE_ASSET__CTR9nk7E__"